"use client";
import { FC } from "react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { SWDCInternalSearchLeftFilter } from "@/components/InternalSearch";

type SWDCInternalSearchLeftFilterBlockProps = {
  showAllCategoriesText?: string;
} & BuilderProps;

export const SWDCInternalSearchLeftFilterBlock: FC<
  SWDCInternalSearchLeftFilterBlockProps
> = ({ showAllCategoriesText }) => {
  return (
    <SWDCInternalSearchLeftFilter
      showAllCategoriesText={showAllCategoriesText}
    />
  );
};
